export const TELEPHONE_COUNTRY_CODES = {
    "US": "+1",
    "CA": "+1",
    "MX": "+52"
};